import React from "react";
var __jsx = React.createElement;
import MobileListingSearchRow from "@/_LayoutsRelated/layout/components/MobileHeader/MobileListingSearchRow";

/**
 * Responsive header for search pages.
 *
 * Search pages pass `hideHeaderOnmobile`, so the layout's `MobileHeader` is
 * hidden here and this is the header the user actually sees. It renders the
 * same shared row as `MobileHeader`'s `listing` variant so the two stay in
 * sync — previously it was a two-row stack (logo above a full-width box).
 */
var SearchHeader = function SearchHeader() {
  return /*#__PURE__*/React.createElement("header", {
    className: "m-show bg-white px-6 py-[15px] shadow-[0_1px_0_0_rgba(0,0,0,0.08)]"
  }, /*#__PURE__*/React.createElement(MobileListingSearchRow, null));
};
export default SearchHeader;